<template>
  <div class="nav-list">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NavList'
}
</script>

<style lang="scss" scoped>
@use '../../scss/variables' as *;

.nav-list {
  padding: 0;
}
</style>
